module.exports = __webpack_public_path__ + "img/07求租.14a40860.jpg";